import {fetchBody, URL_COMPANY_COMPANYLIST, URL_COMPANY_ROLELIST, URL_COMPANY_DEPARTMENTLIST, URL_COMPANY_COMPANYADD, URL_COMPANY_COMPANYEDIT, URL_COMPANY_DEPARTMENTADD, URL_COMPANY_DEPARTMENTEDIT, URL_COMPANY_ROLEADD, URL_COMPANY_ROLEEDIT, URL_COMPANY_ROLELISTBYCOMPANY, URL_COMPANY_COMPANYDETAIL, URL_COMPANY_GET_INFO, URL_COMPANY_ADD_FIRSTEMPLOYEE} from "../config"
import { toFetch, toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";


export const companyAdd = ({mRespCompany, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespCompany, token}), 
      url: URL_COMPANY_COMPANYADD, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        success(jsonDate)
        return jsonDate
      }, 
      failure:(err)=>{
        failure(err)
        return err
      }
    })
  }
  return;
}
export const companyEdit = ({mRespCompany, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    return cleanFetch({
      body: fetchBody({body: mRespCompany, token}), 
      url: URL_COMPANY_COMPANYEDIT, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        success(jsonDate)
        return jsonDate
      }, 
      failure:(err)=>{
        failure(err) 
      }
    })
  }
  return;
}

export const addCompanyFirstEmployee = ({mReqCompanyFirstEmployee, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCompanyFirstEmployee, token}), 
      url: URL_COMPANY_ADD_FIRSTEMPLOYEE, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        success(jsonDate)
        return jsonDate
      }, 
      failure:(err)=>{
        failure(err)
        return err
      }
    })
  }
  return;
}

/**
 * 登入頁面使用
 * @param {*} param0 
 */
export const api_getCompanyInfo = ({texIdNumber, success, failure}) => {  
  cleanFetch({
    body: fetchBody({
      body: {texIdNumber}}), 
    url: URL_COMPANY_GET_INFO, 
    success, 
    failure
  })

}

export const api_getCompanyDetail = ({companyId, success, failure}) => {
  var token = getToken()
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({
        body: {companyId},
        token}), 
      url: URL_COMPANY_COMPANYDETAIL, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }

}

export const getCompanyList = ({applyId, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({
        body: {applyId},
        token}), 
      url: URL_COMPANY_COMPANYLIST, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }

}


export const departmentAdd = ({mRespDepartment, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespDepartment, token}), 
      url: URL_COMPANY_DEPARTMENTADD, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
  return;
}
/**
 * 修改部門資料
 * @param {*} token 
 * @param {*} departmentId 
 * @param {*} departmentName 
 * @param {*} managerDepartmentId 
 * @param {*} isDisable 
 * @param {*} fn 
 */
export const departmentEdit = ({mRespDepartment, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespDepartment, token}), 
      url: URL_COMPANY_DEPARTMENTEDIT, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
  return;
}

export const api_getDepartmentList = ({companyId, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout()
  }else{
    cleanFetch({
      body: fetchBody({
        body: {companyId},
        token}), 
      url: URL_COMPANY_DEPARTMENTLIST, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        //console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
      }, 
      failure
    })
  }
  return;
}

/**
 * 角色新增
 */
export const roleAdd = ({roleName, departmentId, isSupervisor, managerRoleId, isDisable, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    var obj = {
      roleName: roleName,
      departmentId: departmentId,
      isSupervisor: isSupervisor,
      managerRoleId: managerRoleId,
      isDisable: isDisable
    }

    cleanFetch({
      body: fetchBody({body: obj, token}), 
      url: URL_COMPANY_ROLEADD, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
  return;
}

/**
 * 修改角色資料
 * @param {*} token 
 * @param {*} departmentId 
 * @param {*} roleName 
 * @param {*} isSupervisor 
 * @param {*} managerRoleId 
 * @param {*} isDisable 
 * @param {*} fn 
 */
export const roleEdit = ({roleId, roleName, departmentId, isSupervisor, managerRoleId, isDisable, success, failure}) => {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    var obj = {
      roleId: roleId,
      departmentId: departmentId,
      roleName: roleName,
      isSupervisor: isSupervisor,
      managerRoleId: managerRoleId,
      isDisable: isDisable
    }

    cleanFetch({
      body: fetchBody({body: obj, token}), 
      url: URL_COMPANY_ROLEEDIT, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
  return;
}

/**
 * 取得角色列表
 * @param {*} token 
 * @param {*} departmentId 
 * @param {*} fn 
 */
export function api_getRoleList ({departmentId, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout();
  }else{
    cleanFetch({
      body: fetchBody({
        body: {departmentId},
        token}), 
      url: URL_COMPANY_ROLELIST, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        //console.log(jsonDate)
        success(jsonDate, jsonDate.menus)
      }, 
      failure
    })
  }
  return;
}


/**
 * 取得全公司角色列表
 * @param {*} token 
 * @param {*} departmentId 
 * @param {*} fn 
 */
export function getRoleListByCompany ({departmentId, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    
    cleanFetch({
      body: fetchBody({body: {departmentId}, token}), 
      url: URL_COMPANY_ROLELISTBYCOMPANY, 
      success:(jsonDate)=>{
        //var menu = analysisMenu(jsonDate.menus);
        console.log(jsonDate)
        success(jsonDate)
      }, 
      failure
    })
  }
  return;
}